export const EMPLOYEE_FIELDS = [
  "name", "age", "sex", "date_of_birth", "phone", "email", "address", "city", "postal_code",
  "designation", "department", "joining_date", "employment_type", "status", "salary",
  "monthly_target", "area_from", "area_to", "emergency_contact_name", "emergency_contact_phone", "notes",
];

export function employeePayload(form) {
  const payload = {};
  EMPLOYEE_FIELDS.forEach((key) => {
    if (form[key] === undefined) return;
    if (key === "age") {
      if (form.age === "") { payload.age = null; return; }
      const age = Number(form.age);
      if (!Number.isInteger(age) || age < 16 || age > 100) throw new Error("Age must be a whole number between 16 and 100.");
      payload.age = age;
      return;
    }
    if (key === "salary" || key === "monthly_target") {
      if (form[key] === "") { payload[key] = 0; return; }
      const value = Number(form[key]);
      if (!Number.isFinite(value) || value < 0) throw new Error(`${key === "salary" ? "Salary" : "Monthly target"} must be a finite, non-negative number.`);
      payload[key] = value;
      return;
    }
    if (key === "date_of_birth" || key === "joining_date") payload[key] = form[key] || null;
    else payload[key] = form[key] || "";
  });
  if (payload.notes && payload.notes.length > 5000) throw new Error("Notes must be 5,000 characters or fewer.");
  return payload;
}